class CoEarlyAccessNlButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('#klaviyo-early-access-btn');
    this.klaviyoFormId = this.button.dataset.klaviyoFormId;

    if (this.button) {
      this.button.addEventListener('click', this.openKlaviyoForm);
    }
  }

  openKlaviyoForm = () => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', this.klaviyoFormId]);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.openKlaviyoForm);
    }
  }
}

if(!customElements.get('co-early-access-nl-button')) {
  customElements.define('co-early-access-nl-button', CoEarlyAccessNlButton);
}
